module.exports = __webpack_public_path__ + "img/hint_image_gallery_1.36635a1.svg";